<template>
	<div>
		<main role="main" class="error">
			<component :is="component"></component>
		</main>
	</div>
</template>
<script>
import Vue from "vue";

Vue.component("Error403", require("../views/errors/Error403").default);
Vue.component("Error404", require("../views/errors/Error404").default);
Vue.component("Error500", require("../views/errors/Error500").default);

export default {
	computed: {
		status() {
			return this.$store.state.errors.error || "404";
		},
		component() {
			return "Error" + this.status;
		}
	}
};
</script>
